import { useRecoilState, useRecoilValue, useResetRecoilState } from 'recoil';
import { getFleetAssets } from '../../../services/fleetService';
import { apiParamsState } from '../../../storage/app';
import {
  fleetAssetsFiltersState,
  fleetAssetsHasAnyFilterState,
  fleetAssetsReloadListState,
} from '../../../storage/fleetAssets';

export function useFleetAssets() {
  const apiParams = useRecoilValue(apiParamsState);
  const [filters, setFilters] = useRecoilState(fleetAssetsFiltersState);
  const [reload, setReload] = useRecoilState(fleetAssetsReloadListState);
  const resetAllFilters = useResetRecoilState(fleetAssetsFiltersState);
  const hasActiveFilters = useRecoilValue(fleetAssetsHasAnyFilterState);

  const resetFilters = () => {
    setFilters((prev) => ({
      ...prev,
      brandId: undefined,
      subBrandId: undefined,
      assetTypes: [],
    }));
  };

  const onReload = () => {
    setReload((prev) => !prev);
  };

  const onChangeFilter = (filterName: keyof typeof filters, value: any) => {
    setFilters((prev) => ({
      ...prev,
      [filterName]: value,
    }));
  };

  const loadFleetAssets = async () => {
    if (!apiParams)
      return {
        assets: undefined,
        error: 'Selecciona un espacio de trabajo.',
        total: undefined,
      };
    const { assets, error, total } = await getFleetAssets({
      page: filters.page,
      clientId: apiParams.clientId,
      subClientId: apiParams.subClientId,
      assetTypes: filters.assetTypes,
      brandId: filters.brandId,
      subBrandId: filters.subBrandId,
      search: filters.search,
    });
    return {
      assets,
      error,
      total,
    };
  };

  return {
    hasActiveFilters,
    loadFleetAssets,
    onReload,
    reload,
    resetAllFilters,
    resetFilters,
    page: filters.page,
    onChangePage: (page: number) => {
      onChangeFilter('page', page);
    },
    search: filters.search,
    onChangeSearch: (search: string) => {
      onChangeFilter('search', search);
    },
    filters: {
      brandId: filters.brandId,
      subBrandId: filters.subBrandId,
      assetTypes: filters.assetTypes,
    },
    onChangeFilter: (filterName: 'brandId' | 'subBrandId' | 'assetTypes', value: any) => {
      onChangeFilter(filterName, value);
    },
  };
}
